import { render, staticRenderFns } from "./PoleStarWisdomStats.vue?vue&type=template&id=10be4cae&"
import script from "./PoleStarWisdomStats.vue?vue&type=script&lang=js&"
export * from "./PoleStarWisdomStats.vue?vue&type=script&lang=js&"
import style0 from "./PoleStarWisdomStats.vue?vue&type=style&index=0&id=10be4cae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports